/**
 * <s-sticky-add-to-cart>
 * Slides a compact add-to-cart bar up from the bottom of the viewport once the
 * product page's main add-to-cart button has scrolled above the fold.
 * The bar lives inside the product form, so its submit button posts the same form.
 * While hidden it is inert, so it never takes keyboard focus.
 */
class StickyAddToCart extends HTMLElement {
  #observer = null;

  connectedCallback() {
    const target = document.querySelector('[data-main-add]');
    this.#setVisible(false);
    if (!target || !('IntersectionObserver' in window)) return;

    this.#observer = new IntersectionObserver(([entry]) => {
      // Show only when the main button has scrolled up past the top, not before the buyer reaches it.
      const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
      this.#setVisible(scrolledPast);
    });
    this.#observer.observe(target);
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
    this.#observer = null;
  }

  #setVisible(visible) {
    this.toggleAttribute('data-visible', visible);
    this.inert = !visible;
  }
}

if (!customElements.get('s-sticky-add-to-cart')) {
  customElements.define('s-sticky-add-to-cart', StickyAddToCart);
}
